import React, {useEffect, useRef, useState} from "react";
import BodyContainer from "../Common/BodyContainer/BodyContainer";
import {makeStyles, withStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import {checkEmployeeAppointment, getCarsFromACF, getCarTitlesFromWPV2ByIds, sendEmail} from "../HTTPS/apisInterface";
import Lottie from 'react-lottie';
import mailAnimation from './mailAnimation.json';
import {carBrands} from "../../AppConstants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {useHistory} from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Alert from "@material-ui/lab/Alert";
const useStyles = makeStyles((theme) => ({
	margin: {
		margin: theme.spacing(1),
	},
	root: {
	}
}));

export default function (props) {
	const isMobile = useMediaQuery('(max-width:766px)');
	const history = useHistory();
	const externalCarUrl = (() => {
		if (!props.urlSearchParam || typeof props.urlSearchParam !== 'string') return null;
		try {
			const parsed = new URL(props.urlSearchParam);
			return (parsed.protocol === 'http:' || parsed.protocol === 'https:') ? parsed.toString() : null;
		} catch (e) {
			return null;
		}
	})();
	const hasExternalCarUrl = Boolean(externalCarUrl);
	const [image,setImage] = useState();
	const [alert,setAlertView]=useState('hidden');
	const [message,setMessage] = useState({status:"success",message:""});
	const [submitDisableButton,setDisableButton] = useState(false);

	useEffect(()=>{
		const img = new Image();
		img.src =  props.employee.image !== false ? props.employee.image : '/assets/img/manplaceholder.png'; // by setting an src, you trigger browser download
		img.onload = () => {
			setImage(img.src);
		}
		const selectedDate = `${props.currentDate.getFullYear()}-${('0'+(props.currentDate.getMonth()+1)).slice(-2)}-${('0'+props.currentDate.getDate()).slice(-2)}`
		let isFound = false;
		checkEmployeeAppointment({"email":props.employee.email,"start_date":selectedDate}).then((response)=>{
			setLoading(false);
			if(response["message"]){
				history.goBack();
			}
			else{
				response.map(item=>{
					if(item["start"] === props.timeSlot){
						setShowForm(false);
						setShowPage(true);
						isFound = true;
					}
				})
			}
			if(!isFound){
				setShowPage(true);
				setLoading(false);
			}
		})

	},[props.carData])
	const classes = useStyles();
	const StyledBadge = withStyles((theme) => ({
		badge: {
			backgroundColor: props.employee.period === null || props.employee.period.length === 0? '#b80c0c' :'#44b700',
			color: props.employee.period === null || props.employee.period.length === 0 ? '#b80c0c' :'#44b700',
			boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
			'&::after': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				borderRadius: '50%',
				animation: `$ripple 1.2s ${props.employee.period === null || props.employee.period.length === 0	  ? 'once' : 'infinite'} ease-in-out`,
				border: '1px solid currentColor',
				content: '""',
			},
		},
		'@keyframes ripple': {
			'0%': {
				transform: 'scale(.8)',
				opacity: 1,
			},
			'100%': {
				transform: 'scale(2.4)',
				opacity: 0,
			},
		},
	}))(Badge);
	const formRef = useRef(null);
	const formDataInit = {
		voornaam:null,
		naam:null,
		telefoonNummber:null,
		emailAdres:null,
		adres:null,
		huidingVoertuigNummerPlat:null,
		extraInfo:null,
		// Used by the backend (WordPress REST /sendEmails) to identify the selected car.
		carName:null,
		selectedCarModel:null,
		selectedCarCondition:null,
		proefritGewenst:false,
		offerteGewenst:false
	}
	const [formData,updateFormData] = useState(formDataInit);
	const [formErrors,setFormErrors] = useState({});
	const [showForm,setShowForm] = useState(true);
	const [showPage,setShowPage] = useState(false);
	const [acceptPrivacyPolicy,setPrivacyPolicy] = useState(false);

	const [carOptions,setCarOptions] = useState([]);
	const [carsLoading,setCarsLoading] = useState(false);

	// Load car options via ACF cars endpoint (returns IDs), then fetch titles (+ state) via wp/v2/cars.
	// Filters:
	// - Brand: based on URL containing `landrover` or `jaguar` (matched against the car title text)
	// - Condition: based on `props.brandCondition` (matched against wp class_list state-*)
	useEffect(()=>{
		const pathnameLower = (window.location.pathname || '').toLowerCase();
		const showLandRover = pathnameLower.includes('landrover');
		const showJaguar = pathnameLower.includes('jaguar');
		const brandNeedles = showLandRover
			? ['land rover', 'landrover']
			: showJaguar
				? ['jaguar']
				: null;
		const brandClassNeedles = showLandRover
			? ['landrover', 'land-rover']
			: showJaguar
				? ['jaguar']
				: null;

		setCarsLoading(true);
		getCarsFromACF()
			.then((cars)=>{
				const list = Array.isArray(cars) ? cars : [];
				const ids = list.map((car) => (car && car.id != null ? car.id : null)).filter((id) => id != null);
				return getCarTitlesFromWPV2ByIds(ids).then((titles)=>{
					const filtered = titles.filter((t)=>{
						const nameLower = (t?.name || '').toLowerCase();
						const brandByTitle = !brandNeedles || brandNeedles.some((needle) => nameLower.includes(needle));
						const brandByClass = !brandClassNeedles || (
							Array.isArray(t?.brands) &&
							t.brands.some((brand) => brandClassNeedles.includes(String(brand).toLowerCase()))
						);
						return brandByTitle || brandByClass;
					});
					// Keep unique names only (case-insensitive), so duplicates do not appear in the dropdown.
					// On Land Rover pages, remove a leading "Land Rover" prefix from model names.
					const uniqueByName = new Map();
					filtered.forEach((t) => {
						const rawName = t?.name;
						const normalizedName = rawName ? String(rawName).trim() : '';
						if (!normalizedName) return;
						const displayName = showLandRover
							? normalizedName.replace(/^land[\s-]*rover\s+/i, '')
							: normalizedName;
						const finalName = displayName.trim();
						if (!finalName) return;
						const key = finalName.toLowerCase();
						if (!uniqueByName.has(key)) {
							uniqueByName.set(key, { name: finalName });
						}
					});
					const sortedOptions = Array.from(uniqueByName.values()).sort((a, b) =>
						String(a.name).localeCompare(String(b.name), 'nl', { sensitivity: 'base' })
					);
					setCarOptions(sortedOptions);
				});
			})
			.catch(()=>{
				setCarOptions([]);
			})
			.finally(()=>{
				setCarsLoading(false);
			});
	},[]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		updateFormData({
			...formData,
			[name]: value
		});
		if(name === 'telefoonNummber'){
			setFormErrors((prev) => ({
				...prev,
				telefoonNummber: value ? !validateBelgianPhoneField(value) : false
			}));
		}
	};
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: mailAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};
	const validateTextField = (value)=>{
		if(value === null) return false;
		if(value === " ") return false;
		return true;
	}
	const validateEmailField = (value)=>{
		if(value == null) return false;
		const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
		return emailPattern.test(value);
	}
	const validateBelgianPhoneField = (value)=>{
		if(value == null) return false;
		const normalizedPhone = String(value).trim().replace(/[\s\-\.\(\)\/]+/g, '');
		const belgianPhonePattern = /^\+32[1-9]\d{7,8}$/;
		return belgianPhonePattern.test(normalizedPhone);
	}
	const [loading,setLoading] = useState(true);
	const sendEmails = ()=>{
		let errorsObject = {};
		Object.keys(formData).forEach(item=>{
			let validation = validateTextField(formData[item]);
			if(item === 'emailAdres'){
				validation = validateEmailField(formData[item]);
			}
			if(item === 'telefoonNummber'){
				validation = validateBelgianPhoneField(formData[item]);
			}
			if(validation === false){
				const isOptionalCarField = hasExternalCarUrl && (item === 'carName' || item === 'selectedCarModel');
				const isOptionalConditionField = item === 'selectedCarCondition' && !props.isDirectSalespersonBooking;
				if(item !== 'adres' && item !=='huidingVoertuigNummerPlat' && item !== 'extraInfo' && !isOptionalCarField && !isOptionalConditionField){
					errorsObject[item] = true;
				}
			}
		})
		setFormErrors(errorsObject);
		if(Object.keys(errorsObject).length === 0){
			setDisableButton(true);

			formData['locationName'] = props.brand.currentLocationFullName;
			formData['location'] = props.brand.currentLocationFullName;
			const extraHour = `${('0'+(parseInt(props.timeSlot.split(":")[0] ) + 1)).slice(-2)}:${props.timeSlot.split(":")[1]}`;
			let startEventDate = `${props.currentDate.toISOString().split("T")[0]}T${props.timeSlot}`;
			let endEventDate = `${props.currentDate.toISOString().split("T")[0]}T${extraHour}`;
			const extraShiftedHour = `${parseInt(props.timeSlot.split(":")[0] ) -1}:${props.timeSlot.split(":")[1]}`;
			let shiftedStartEvent = `${props.currentDate.toISOString().split("T")[0]}T${props.timeSlot.split(":")[0]-2+":"+props.timeSlot.split(":")[1]}`;
			let shiftedEventEnd = `${props.currentDate.toISOString().split("T")[0]}T${extraShiftedHour}`;
			formData['startDate'] = startEventDate;
			formData['shiftedStartEvent'] = shiftedStartEvent;
			formData['shiftedEventEnd'] = shiftedEventEnd;
			formData['selectedDate'] =`${props.currentDate.toLocaleDateString('nl-BE',{ weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })} - ${props.timeSlot} -> ${extraHour} `;
			formData['endDate'] = endEventDate;
			formData['startTime'] = startEventDate;
			formData['endTime'] = endEventDate;
			formData['employeeName'] = props.employee.name;
			formData['employeeEmail'] = props.employee.email;
			formData['salespersonEmail'] = props.employee.email;
			formData['carCondition'] = props.isDirectSalespersonBooking
				? formData.selectedCarCondition
				: props.brandCondition;
			formData['brandName'] = props.brand.name;
			formData['nummerPlaat'] = formData['huidingVoertuigNummerPlat'];
			sendEmail(formData)
				.then((response) => {
					// Backend responses can be either strings ("202") or numbers (202) depending on environment/PHP.
					const statusEmployee = Number(response?.statusEmployee);
					const statusClient = Number(response?.statusClient);
					const statusReserved = Number(response?.statusReserved);

					// Reservation success is the critical outcome for UX/navigation.
					// Emails can fail independently after the appointment has already been created.
					if(statusReserved === 202){
					props.reactGA.pageview(window.location.pathname + window.location.search +"?success=true");
					props.reactGA.event({
						category: "Booking",
						action: (statusEmployee === 202 && statusClient === 202) ? "Form success" : "Form success with email warning"
					})
					history.push({search:"success=true",state:history.location.state})
					setShowForm(false);
					updateFormData(formDataInit);
					setDisableButton(false);
				}else{
					setAlertView('visible');
					setTimeout(()=>{
						setAlertView('hidden');
					},2400);
					setDisableButton(false);
					setMessage({message:"Error Failed to book please try again or contact support",status: "error"})
				}
				})
				.catch((err) => {
					// Network/backend error: keep the UI responsive and inform the user.
					console.error('sendEmails failed', err);
					setAlertView('visible');
					setTimeout(()=>{
						setAlertView('hidden');
					},2400);
					setDisableButton(false);
					setMessage({message:"Error Failed to book please try again or contact support",status: "error"})
				});
		}

	}
	const selectedCarValue = carOptions.find((car) =>
		(car && car.name != null && String(car.name) === String(formData.selectedCarModel))
	) || null;
	const showCarOptionsSection = selectedCarValue || hasExternalCarUrl;
	const showConditionSelector = props.isDirectSalespersonBooking && showCarOptionsSection;
	const selectedConditionValue = formData.selectedCarCondition
		? { name: formData.selectedCarCondition === 'new' ? 'Nieuw' : 'Tweedehands', value: formData.selectedCarCondition }
		: null;
	const conditionOptions = [
		{ name: 'Nieuw', value: 'new' },
		{ name: 'Tweedehands', value: 'used' },
	];
	return(<React.Fragment>
			 <BodyContainer {...props} childComponent={<React.Fragment>
				 { loading ? <div className={'col'}><div style={{display:'flex',justifyContent:'center',marginTop:'80px'}}><CircularProgress /></div></div> :showPage ? showForm ? <div style={{marginRight:'auto',marginLeft:'auto',paddingTop:'30px'}}>
					<h4 style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar':'LandRover'}`}}>Bevestig uw afspraak</h4>
					 <div style={{flexDirection:isMobile ? 'column':'row'}} className={'col flex centerItems'}>
						 {isMobile ? <div>
							 {/*'col col-lg-4 col-md-6 col-sm-6*/}
							 <div  className={'form'} style={{paddingTop:'20px'}} >
								 <div className={'flex'} style={{ flexDirection: 'column' }}>
									 <Card style={{width:'100%',marginRight:'20px',background:`${props.brand.name === carBrands.jaguar.title ? 'linear-gradient(#9e1b32 50%, white 50%)':"linear-gradient(rgb(0 0 0) 50%, white 50%)"}`}} className={classes.root}>
										 <CardActionArea >
											 <div className={"imageContainer"} style={{position:'relative', width:'fit-content', margin:'0 auto'}}>
												 <CardMedia
														component="img"
														alt={props.employee.name}
														height="150px"
														id={`${props.employee.name.split(" ").join('')}`}
														style={{objectFit:"cover",width:'150px',borderRadius:'50%'}}
														image={image}
														title={props.employee.name}
												 />
												 <StyledBadge
														overlap="circle"
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'right',
														}}
														style={{position:'absolute',right:10,bottom:10}}
														variant="dot"
												 />
											 </div>

											 <CardContent>
												 <Typography className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Main':'landrover-font-Main'}`} gutterBottom variant="h5" component="h2">
													 {props.employee.name}
												 </Typography>
												 <Typography variant="body2"  component="p">
													 Locatie : {props.brand.currentLocationFullName}
												 </Typography>
												 <Typography variant="body2"  component="p">
													 Vanaf : {props.currentDate.toLocaleDateString('nl-BE',{ weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })} - {props.timeSlot}
												 </Typography>
											 </CardContent>
										 </CardActionArea>
									 </Card>
										<div style={{marginTop: 24, marginBottom: 16, padding: 16, border: '1px solid #e0e0e0', borderRadius: 4, backgroundColor: '#fafafa'}}>
										 <Typography variant="subtitle1" style={{marginBottom: 12, fontFamily: props.brand.name === carBrands.jaguar.title ? 'Jaguar' : 'LandRover'}}>Wagen & opties</Typography>
										 {hasExternalCarUrl ? (
											 <div style={{padding: 12, backgroundColor: '#f5f5f5', marginBottom: 12}}>
												 <Typography variant="body2" className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'}>
													 U wilt een afspraak maken voor{' '}
													 <a href={externalCarUrl} target="_blank" rel="noopener noreferrer">deze wagen</a>.
												 </Typography>
											 </div>
										 ) : (
											 <Autocomplete
												 options={carOptions}
												 loading={carsLoading}
												 loadingText="Laden..."
												 getOptionLabel={(option) => {
													 if (!option) return "";
													 return option.name || "";
												 }}
												 value={selectedCarValue}
												 onChange={(e, newValue) => {
													 const selectedKey = newValue ? newValue.name : null;
													 updateFormData({ ...formData, selectedCarModel: selectedKey, carName: selectedKey });
												 }}
												 renderInput={(params) => (
													 <TextField
														 {...params}
														 required
														 error={Boolean(formErrors.selectedCarModel || formErrors.carName)}
														 label="Merk"
														 variant="outlined"
														 placeholder="Zoek een wagen..."
													 />
												 )}
												 style={{marginBottom: 16}}
											 />
										 )}
										 {showCarOptionsSection && (
											 <>
												 {showConditionSelector && (
													 <Autocomplete
														 options={conditionOptions}
														 getOptionLabel={(option) => (option && option.name) ? option.name : ""}
														 value={selectedConditionValue}
														 onChange={(e, newValue) => {
															 updateFormData({ ...formData, selectedCarCondition: newValue ? newValue.value : null });
														 }}
														 renderInput={(params) => (
															 <TextField
																 {...params}
																 required
																 error={Boolean(formErrors.selectedCarCondition)}
																 label="Conditie"
																 variant="outlined"
																 placeholder="Kies nieuw of tweedehands"
															 />
														 )}
														 style={{marginBottom: 16}}
													 />
												 )}
												 <FormControlLabel
													 control={
														 <Checkbox
															 color="primary"
															 checked={formData.proefritGewenst}
															 onChange={() => updateFormData({ ...formData, proefritGewenst: !formData.proefritGewenst })}
															 name="proefritGewenst"
														 />
													 }
													 label={<span className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'} style={{color: 'black'}}>Ik wil een proefrit maken indien de wagen beschikbaar is (een proefrit kan niet gegarandeerd worden tijdens uw afspraak).</span>}
												 />
												 <div>
													 <FormControlLabel
														 control={
															 <Checkbox
																 color="primary"
																 checked={formData.offerteGewenst}
																 onChange={() => updateFormData({ ...formData, offerteGewenst: !formData.offerteGewenst })}
																 name="offerteGewenst"
															 />
														 }
														 label={<span className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'} style={{color: 'black'}}>Ik wil graag een offerte voor bovenstaand model</span>}
													 />
												 </div>
											 </>
										 )}
									 </div>
								 </div>
							 </div>
						 </div>: <div style={{marginRight:'41px'}} className={''}>
							 {/*'col col-lg-4 col-md-6 col-sm-6*/}
							 <div style={{maxWidth:'256px'}} className={'form'}>
								 <div className={'flex flex-column'}>
									 <Card style={{background:`${props.brand.name === carBrands.jaguar.title ? 'linear-gradient(#9e1b32 50%, white 50%)':"linear-gradient(rgb(0 0 0) 50%, white 50%)"}`}} className={classes.root}>
										 <CardActionArea >
											 <div className={"imageContainer"} style={{position:'relative', width:'fit-content', margin:'0 auto'}}>
												 <CardMedia
														component="img"
														alt={props.employee.name}
														height="110px"
														id={`${props.employee.name.split(" ").join('')}`}
														style={{objectFit:"cover",width:'110px',borderRadius:'50%'}}
														image={image}
														title={props.employee.name}
												 />
												 <StyledBadge
														overlap="circle"
														anchorOrigin={{
															vertical: 'bottom',
															horizontal: 'right',
														}}
														style={{position:'absolute',right:8,bottom:8}}
														variant="dot"
												 />
											 </div>

											 <CardContent>
												 <Typography className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Main':'landrover-font-Main'}`} gutterBottom variant="h5" component="h2">
													 {props.employee.name}
												 </Typography>
												 <Typography className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary':'landrover-font-Secondary'}`} variant="body2"  component="p">
													 Locatie : {props.brand.currentLocationFullName}
												 </Typography>
												 <Typography className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary':'landrover-font-Secondary'}`} variant="body2"  component="p">
													 Vanaf : {props.currentDate.toLocaleDateString('nl-BE',{ weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })} - {props.timeSlot}
												 </Typography>
											 </CardContent>
										 </CardActionArea>
									 </Card>
										<div style={{marginTop: 24, marginBottom: 16, padding: 16, border: '1px solid #e0e0e0', borderRadius: 4}}>
											 <Typography variant="subtitle1" style={{marginBottom: 12, fontFamily: props.brand.name === carBrands.jaguar.title ? 'Jaguar' : 'LandRover'}}>Wagen & opties</Typography>
											 {hasExternalCarUrl ? (
												 <div style={{padding: 12, backgroundColor: '#f5f5f5', marginBottom: 12}}>
													 <Typography variant="body2" className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'}>
														 U wilt een afspraak maken voor{' '}
														 <a href={externalCarUrl} target="_blank" rel="noopener noreferrer">deze wagen</a>.
													 </Typography>
												 </div>
											 ) : (
												 <Autocomplete
													 options={carOptions}
													 loading={carsLoading}
													 loadingText="Laden..."
													 getOptionLabel={(option) => {
														 if (!option) return "";
														 return option.name || "";
													 }}
													 value={selectedCarValue}
													 onChange={(e, newValue) => {
														 const selectedKey = newValue ? newValue.name : null;
														 updateFormData({ ...formData, selectedCarModel: selectedKey, carName: selectedKey });
													 }}
													 renderInput={(params) => (
														 <TextField
															 {...params}
															 required
															 error={Boolean(formErrors.selectedCarModel || formErrors.carName)}
															 label="Merk"
															 variant="outlined"
															 placeholder="Zoek een wagen..."
														 />
													 )}
													 style={{marginBottom: 16}}
												 />
											 )}
											 {showCarOptionsSection && (
												 <>
													 {showConditionSelector && (
														 <Autocomplete
															 options={conditionOptions}
															 getOptionLabel={(option) => (option && option.name) ? option.name : ""}
															 value={selectedConditionValue}
															 onChange={(e, newValue) => {
																 updateFormData({ ...formData, selectedCarCondition: newValue ? newValue.value : null });
															 }}
															 renderInput={(params) => (
																 <TextField
																	 {...params}
																	 required
																	 error={Boolean(formErrors.selectedCarCondition)}
																	 label="Conditie"
																	 variant="outlined"
																	 placeholder="Kies nieuw of tweedehands"
																 />
															 )}
															 style={{marginBottom: 16}}
														 />
													 )}
												 	<div>
														 <FormControlLabel
															 style={{alignItems: 'flex-start'}}
															 control={
																 <Checkbox
																	 style={{marginTop: '-5px'}}
																	 color="primary"
																	 checked={formData.offerteGewenst}
																	 onChange={() => updateFormData({ ...formData, offerteGewenst: !formData.offerteGewenst })}
																	 name="offerteGewenst"
																 />
															 }
															 label={<span className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'} style={{color: 'black'}}>Ik wil graag een offerte voor bovenstaand model</span>}
														 />
													 </div>
													 <FormControlLabel
														 style={{alignItems: 'flex-start'}}
														 control={
															 <Checkbox
																 style={{marginTop: '-5px'}}
																 color="primary"
																 checked={formData.proefritGewenst}
																 onChange={() => updateFormData({ ...formData, proefritGewenst: !formData.proefritGewenst })}
																 name="proefritGewenst"
															 />
														 }
														 label={<span className={props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary' : 'landrover-font-Secondary'} style={{color: 'black'}}>Ik wil een proefrit maken indien de wagen beschikbaar is (een proefrit kan niet gegarandeerd worden tijdens uw afspraak).</span>}
													 />
												 </>
											 )}
										 </div>
								 </div>
							 </div>
						 </div>}
						 <div className={''}>
							 {/*col col-lg-8 col-md-6 col-sm-7*/}
							 <div className={'form'}>
								 <div className={'formContainer'}>
									 <form  ref={formRef}  className={'container'}  autoComplete="on">
										 <h4 style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar':'LandRover'}`}}>Persoonlijke gegevens</h4>
										 <FormControl error={formErrors.voornaam}>
											 <TextField  error={formErrors.voornaam} name={"voornaam"} onChange={handleChange} required label="Voornaam" />
											 {formErrors.voornaam ? <FormHelperText >Please enter your first name</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.naam}>
											 <TextField error={formErrors.naam} name={'naam'} onChange={handleChange} required  label="Naam" />
											 {formErrors.naam ? <FormHelperText >Please enter your last/mid name</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.telefoonNummber}>
											 <TextField
												 error={formErrors.telefoonNummber}
												 name={'telefoonNummber'}
												 onChange={handleChange}
												 type="tel"
												 required
												 label="Telefoon Nummer"
												 placeholder="+32471234567"
											 />
											 {formErrors.telefoonNummber ? <FormHelperText >Vul een geldig Belgisch nummer in dat start met +32</FormHelperText>:''}
										 </FormControl>
										 <FormControl error={formErrors.emailAdres}>
											 <TextField error={formErrors.emailAdres} name={'emailAdres'} onChange={handleChange} required  label="E-mailadres " />
											 {formErrors.emailAdres ? <FormHelperText >Please Enter Valid Email Address</FormHelperText>:''}
										 </FormControl>
										 <TextField error={formErrors.adres} name={'adres'} onChange={handleChange} label="Adres" />
										 <TextField error={formErrors.huidingVoertuigNummerPlat} name={'huidingVoertuigNummerPlat'} onChange={handleChange} label={"Huidig voertuig + nummerplaat"}/>

										 <TextField onChange={handleChange}
																id="outlined-multiline-static"
																label="Extra Info"
																multiline
																rows={4}
													            defaultValue={props.urlSearchParam ? `Ik ben geïnteresseerd in volgende wagen: \n\r ${props.urlSearchParam}`:null}
																error={formErrors.extraInfo}
																name={"extraInfo"}
																variant="outlined"
										 />
										 <FormControlLabel
												control={<Checkbox color="primary" checked={acceptPrivacyPolicy} onChange={()=>{ setPrivacyPolicy(!acceptPrivacyPolicy)}} name="checkedA" />}
												label={<span className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary':'landrover-font-Secondary'}`} style={{color:'black'}} >Ik ga akkoord met de <a style={{color:`${props.brand.name === carBrands.jaguar.title ? '#9e1b32' :'black'}`,fontWeight:'bolder'}} target={"_blank"} href={'https://www.jaguarmetropoolnoord.be/nl/privacy-policy/'}>Privacy Policy</a></span>}
										 />


										 <Button className={`${props.brand.name === carBrands.jaguar.title ? 'jaguar-font-Secondary':'landrover-font-Secondary'}`}
														 disabled={!acceptPrivacyPolicy || submitDisableButton}
														 onClick={()=>{sendEmails()}}
														 variant="contained"
														 style={{color:'white',backgroundColor:`${props.brand.name === carBrands.jaguar.title ? '#9e1b32' :'black'}`}}
														 color="primary">
											 Verzend {submitDisableButton ? <CircularProgress style={{marginLeft:"10px"}} size={20} />:''}
										 </Button>

									 </form>
								 </div>
							 </div>
						 </div>
					 </div>
				 </div>:<div className={'col'} style={{textAlign:'center',color:"black"}}>
					 <Lottie
							options={defaultOptions}
							height={400}
							width={400}
					 />
					 <h3 style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar':'LandRover'}`, fontWeight: 800}}>Uw aanvraag is verzonden.</h3>
					 <h3 style={{fontFamily:`${props.brand.name === carBrands.jaguar.title ? 'Jaguar':'LandRover'}`, fontSize: '1.5rem'}}>U ontvangt zo dadelijk een bevestiging via email.</h3>
				 </div> :''}

			 </React.Fragment>}/>
		<Alert   style={{width:'fit-content',position:'absolute',top:'18%',left:'0',right:'0',marginLeft:'auto',marginRight:'auto',visibility:alert}} severity={message.status}>{message.message}</Alert>
		 </React.Fragment>)
}
